import { render, staticRenderFns } from "./PdTab.vue?vue&type=template&id=a102353c&scoped=true&"
import script from "./PdTab.vue?vue&type=script&lang=ts&"
export * from "./PdTab.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a102353c",
  null
  
)

export default component.exports